import * as angular from 'angular';
import * as moment from 'moment';
import EditHotEndBonus, { openEditHotEndBonus } from "./editHotEndBonus.controller";
import { States } from "../../shared/config/constant.module";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { Plant } from "../../models/navigation";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotifyServiceName, { NotifyService } from '../../services/notify/notify.service';
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import holidaysService, { HolidaysService } from '../../services/holidays/holidays.service';
import * as _ from "lodash";
import template from './hotEndBonusReport.tpl.html';

let requires = [LoaderServiceName, ReportServiceName, NavigationServiceName, EditHotEndBonus,
  AuthDataServiceName, NotifyServiceName];

export default angular.module('aps.controller.hotEndBonusReport', requires)
  .config(hotEndBonusConfig)
  .controller('HotEndBonusCtrl', hotEndBonusController)
  .name;

function hotEndBonusConfig($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.HOT_END_BONUS,
    url: '/admin/hotEndBonusReport',
    controller: 'HotEndBonusCtrl as vm',
    template: template,
    data: {
      pageTitle: 'Hot End Bonus Report'
    }
  });
}
class SignOffUsers{
  UserId: string;
  UserName: string;
  SignedOffDate: string;
}
interface HotEndBonusController {
  hotEndBonuses: apsViewModels.HotEndBonusDetails;
  sigOffData : apsViewModels.SignOffItems;
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  plants: Plant[];
  generateReport(): void;
  iseditable: boolean;
  reportDate: Date;
  formattedReportDate: string;
  edit(instance: apsViewModels.HotEndBonusItem): void;
  getSignOff():angular.IPromise<any>;
  signOff(): angular.IPromise<apsViewModels.SignOffItems>;
  userList : SignOffUsers[];
  minDate: Date;
  isSignedOff: boolean;
  holidays: apsViewModels.Holiday[];
}

function hotEndBonusController(loaderService: LoaderService,
  reportService: ReportService,
  notifyService: NotifyService,
  navigationService: NavigationService,
  authDataService: AuthDataService,
  holidaysService : HolidaysService,
  $modal: mm.foundation.modal) {
  let vm = {} as HotEndBonusController;

  let loadingPromise = navigationService.getNavigation().then(nav => {
    vm.plants = nav.plants();
    if (nav.selectedPlant && _.includes(vm.plants, nav.selectedPlant)) {
      vm.selectedPlant = nav.selectedPlant;
    } else {
      vm.selectedPlant = _.first(vm.plants);
      vm.selectedShop = nav.selectedShop;
    }
  });

  let holidayPromise = holidaysService.getHolidays(moment().year()).then( holidays => {
    vm.holidays = holidays;
  });

  loaderService.loadingPromise(holidayPromise);
  loaderService.loadingPromise(loadingPromise);
  vm.edit = edit;
  vm.reportDate = moment().add(-1, 'days').toDate();
  vm.formattedReportDate = moment(vm.reportDate).format("dddd, MM/DD/YYYY");
  vm.minDate = moment().add(-365, 'days').toDate();
  vm.generateReport = generateReport;  
  vm.signOff = signOff;
  vm.getSignOff = getSignOff;
  return vm;

  function checkIfEditable(): boolean { 
    const today = new Date();
    today.setHours(0, 0, 0, 0);  
    const currentDay = today.getDay();  
    const currentWeekStart = new Date(today.getTime());
    currentWeekStart.setDate(today.getDate() - currentDay);
    const lastWeekStart = new Date(currentWeekStart.getTime());
    lastWeekStart.setDate(currentWeekStart.getDate() - 7);
    const lastWeekEnd = new Date(currentWeekStart.getTime());
    lastWeekEnd.setDate(currentWeekStart.getDate() - 1);
    const isSunday = currentDay === 0;
    const isMonday = currentDay === 1;
    const isTuesday = currentDay === 2;
    const yesterday = new Date(today.getTime());
    yesterday.setDate(today.getDate() - 1);
    const isMondayHoliday = vm.holidays.some(holiday => {
      const h = new Date(holiday.date.getTime());
      h.setHours(0, 0, 0, 0);
      return h.getTime() === yesterday.getTime();
    });
    const reportDate = new Date(vm.reportDate.getTime());
    reportDate.setHours(0, 0, 0, 0);  
    const isInCurrentWeek = reportDate >= currentWeekStart && reportDate <= today;
    const isInLastWeek = reportDate >= lastWeekStart && reportDate <= lastWeekEnd;  
    const canEditLastWeek = isInLastWeek && (isSunday || isMonday || (isTuesday && isMondayHoliday));  
    return isInCurrentWeek || canEditLastWeek;
  }

  function generateReport(): angular.IPromise<any> {
    vm.iseditable = checkIfEditable();
    vm.formattedReportDate = moment(vm.reportDate).format("dddd, MM/DD/YYYY");
    var promise = runReport();
    loaderService.loadingPromise(promise);
    getSignOff();
    return promise;
  }
  function runReport(): angular.IPromise<any> {
    var fomratdateonly = new Date(moment(vm.reportDate).format("MM/DD/YYYY"));
    vm.hotEndBonuses = null;
    return reportService.getPlantHotEndBonus(vm.selectedPlant.id, fomratdateonly).then(reportItem => {
      vm.hotEndBonuses = reportItem;
    }, notifyService.handleApiErrors);

  }

  function getSignOff(): angular.IPromise<any>{
    let currentUser = authDataService.getUserData(); 
    let plantId = vm.selectedPlant.id; 
    let productionDate = new Date(moment(vm.reportDate).format("MM/DD/YYYY"));
 
    return reportService.getHotEndSignOff(plantId, productionDate).then(signOffitem => 
      { 
        vm.sigOffData = signOffitem; 
        vm.userList = vm.sigOffData.signOffUsers != undefined ? JSON.parse(vm.sigOffData.signOffUsers) : null; 
        vm.isSignedOff = vm.userList != null ? ( vm.userList.filter(x => x.UserId == currentUser.id).length === 0 ? false : true) : false ;
      });
  }

  function signOff(): angular.IPromise<apsViewModels.SignOffItems>{
    const signedDate = new Date().toLocaleDateString('en-US');       
    const signedTime = new Date().toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });                                             
    const signOffDate = (`${signedDate} ${signedTime}`).toString(); 
    let currentUser = authDataService.getUserData(); 
    let plantId = this.selectedPlant.id;
    let productionDate = new Date(moment(vm.reportDate).format("MM/DD/YYYY"));
    let user = `${currentUser.id},${currentUser.fullName},${signOffDate}`;  
    let newUser: SignOffUsers = { UserId: currentUser.id, UserName : currentUser.fullName, SignedOffDate: signOffDate}
    if(vm.isSignedOff){
      vm.userList = (vm.userList === null || vm.userList === undefined || vm.userList.length == 0) ? [] : vm.userList;
      vm.userList.push(newUser)
    }
    else{
      _.remove(vm.userList, x => x.UserId == currentUser.id)
    }

    let hotEndCommand : apsViewModels.SignOffItems = {
      plantId : plantId,
      productionDate : productionDate,
      isSignedOff : vm.isSignedOff,
      signOffUsers : user
    };
    return reportService.updateSignOffUsers(hotEndCommand);
  }

  function edit(instance: apsViewModels.HotEndBonusItem): void {
    let result = openEditHotEndBonus({
      plant: vm.selectedPlant,
      hotEndBonusItem: instance,
      productionDate: vm.reportDate
    }, $modal);
    result.then((result) => {
      if (!result) {
        return;
      }
      var shopname = _.find(vm.selectedPlant.shops, { id: result.shopId }).name;
      vm.hotEndBonuses.shopDetailItems.filter(x=>x.shopName == shopname)[0].hotEndBonusItems.splice(vm.hotEndBonuses.shopDetailItems.filter(x=>x.shopName == shopname)[0].hotEndBonusItems.indexOf(instance), 1 , result);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/controllers/reports/hotEndBonusReport.controller.ts